module.exports = __webpack_public_path__ + "img/youtube.0698fc5c.png";